import { useMutation } from "@tanstack/react-query";
import { useCallback, useState } from "react";
import { CourseData, COURSE_STATUS, CreateCourseRequest } from "@vixi/types";
import api from "@vixi/api";
import { courseToSavedCourse } from "@vixi/utils";

interface CourseToSavedCourseOptions {
  course: CourseData.Course;
  draft?: boolean;
}

export const useSaveCourse = () => {
  const [progress, setProgress] = useState<number>(0);

  const mutationFn = useCallback(
    async ({ course, draft = false }: CourseToSavedCourseOptions) => {
      const response = await api.post<number>(
        api.endpoints.saveCourse,
        {
          course: courseToSavedCourse(
            {
              ...course,
              courseStatus: draft ? COURSE_STATUS.DRAFT : COURSE_STATUS.WAITING_PUBLISH,
            },
            {
              ignoreId: true,
            },
          ),
        } as CreateCourseRequest,
        {
          onUploadProgress: (e) => {
            setProgress(Math.round((e.loaded * 50) / (e.total ?? 1)));
          },
          onDownloadProgress: (e) => {
            setProgress(50 + Math.round((e.loaded * 50) / (e.total ?? 1)));
          },
        },
      );

      return response.data;
    },
    [setProgress],
  );

  const mutation = useMutation({
    mutationKey: ["save-course"],
    mutationFn,
  });

  return {
    ...mutation,
    progress,
  };
};
